import React from 'react';
import EmptyStateIcon from '../svg/EmptyState';

const EmptyAgenda = ({ text, subtext }) => {

	return (
		<div className="agenda-no-results grid-item">
				<h2 className="text-big agenda-no-results__title">
					{text}
				</h2>

				<div className='agenda-no-results__icon-container'>
					<EmptyStateIcon />
				</div>

				{ subtext &&
					<p className="agenda-no-results__subtext">{subtext}</p>
				}
		</div>
	);
}

export default EmptyAgenda;
